import { render, staticRenderFns } from "./update-restitution-nutritive-modal.vue?vue&type=template&id=6b0bff73&scoped=true"
import script from "./update-restitution-nutritive-modal.vue?vue&type=script&lang=js"
export * from "./update-restitution-nutritive-modal.vue?vue&type=script&lang=js"
import style0 from "./update-restitution-nutritive-modal.vue?vue&type=style&index=0&id=6b0bff73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bff73",
  null
  
)

export default component.exports